/* ============================================================================
   tne-loader.js — Loading screen TopBioEuropa (wordmark fill)

   Animação:
     - --tne-loader-p (0..100) anima de 0 a 100 ao longo de PROGRESS_MS via rAF.
     - Texto do contador (data-tne-loader-pct) atualiza em sincronia.
     - Quando atinge 100% E o `window.load` já disparou (whichever later),
       o loader faz fade out e é removido do DOM.
     - Safety MAX: força hide após SAFETY_MS independentemente do estado real
       (fallback para conexões muito lentas).

   Sessão: sessionStorage flag mantida — só aparece na 1.ª navegação por sessão.
   Acessibilidade: respeita prefers-reduced-motion (CSS já trata o aspeto).
   ============================================================================ */
(function () {
  'use strict';

  var STORAGE_KEY = 'tne-loader-shown';
  var PROGRESS_MS = 1600;   // duração da animação 0->100
  var SAFETY_MS = 2000;     // hard-cap: o loader nunca fica visível mais de 2s
  var FADE_MS = 600;        // sincronizado com transition CSS

  // 1.ª navegação? Se já mostrado, retira logo sem animar.
  if (sessionStorage.getItem(STORAGE_KEY) === '1') {
    var existing = document.getElementById('TneLoader');
    if (existing && existing.parentNode) {
      existing.parentNode.removeChild(existing);
    }
    return;
  }

  function start() {
    var loader = document.getElementById('TneLoader');
    if (!loader) return;

    var pctEl = loader.querySelector('[data-tne-loader-pct]');

    var startTime = performance.now();
    var hidden = false;
    var progressDone = false;
    var loadDone = document.readyState === 'complete';

    var safetyTimer = window.setTimeout(hideLoader, SAFETY_MS);

    function hideLoader() {
      if (hidden) return;
      hidden = true;
      window.clearTimeout(safetyTimer);

      // Garante que o wordmark fica 100% preenchido no fade out.
      loader.style.setProperty('--tne-loader-p', 100);
      if (pctEl) pctEl.textContent = '100%';

      loader.dataset.state = 'hidden';
      sessionStorage.setItem(STORAGE_KEY, '1');

      // Sinaliza ao resto da página (ex.: tne-hero.js) que o loading screen
      // terminou — usado para arrancar o vídeo de fundo do hero no momento
      // exacto em que o loader desaparece.
      document.dispatchEvent(new CustomEvent('tne:loader-hidden'));

      window.setTimeout(function () {
        if (loader && loader.parentNode) {
          loader.parentNode.removeChild(loader);
        }
      }, FADE_MS + 50);
    }

    function maybeHide() {
      if (progressDone && loadDone) {
        hideLoader();
      }
    }

    // Easing cubic out — começa rápido, decay suave.
    function easeOutCubic(t) {
      return 1 - Math.pow(1 - t, 3);
    }

    function tickProgress(now) {
      if (hidden) return;
      var elapsed = now - startTime;
      var t = elapsed / PROGRESS_MS;
      if (t > 1) t = 1;

      // Até 90% segue PROGRESS_MS. Os últimos 10% só completam quando o
      // `load` event do window já tiver disparado — alinha a sensação
      // visual com o estado real da página.
      var ceiling = loadDone ? 100 : 90;
      var visualPct = easeOutCubic(t) * ceiling;
      if (visualPct > ceiling) visualPct = ceiling;

      loader.style.setProperty('--tne-loader-p', visualPct.toFixed(2));
      if (pctEl) pctEl.textContent = Math.round(visualPct) + '%';

      if (visualPct >= 100) {
        progressDone = true;
        maybeHide();
        return;
      }

      // Continua o rAF se ainda há animação OU estamos abaixo do teto.
      // Se atingiu o teto de 90% à espera do load, pára aqui — o handler
      // do load retoma o tickProgress quando dispara.
      if (t < 1 || visualPct < ceiling) {
        requestAnimationFrame(tickProgress);
      }
    }

    if (document.readyState === 'complete') {
      loadDone = true;
    } else {
      window.addEventListener('load', function () {
        loadDone = true;
        // Se a animação já parou em 90% à espera, retoma para fechar até 100.
        if (!progressDone && !hidden) {
          requestAnimationFrame(tickProgress);
        } else {
          maybeHide();
        }
      }, { once: true });
    }

    requestAnimationFrame(tickProgress);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
